import React from 'react'

export default () => (
  <div className="login-bubbles">
    <div className="big-bubble">
      {__.trans('login.login-bubbles-your-personal-info')}
      <br />
    </div>
    <div className="small-bubble"> {__.trans('login.login-bubbles-thank-you')}</div>
  </div>
)
